import React from "react";
import MessengerCustomerChat from "react-messenger-customer-chat";

const Messenger = () => {
  return (
    <div>
      <MessengerCustomerChat
        pageId="110280248282314"
        appId="1042568009949735"
      />
    </div>
  );
};

export default Messenger;
